<template>
  <!-- 有输入框 -->
  <div>
    <div ref="tableList" class="image-upload-multiple" style="padding-top: 10px; display:flex;flex-wrap: wrap;">
        <div v-for="(item,index) in defaultFileList" :key="item.id"  style="padding-bottom: 5px;position: relative;">
          <div class="content">
            <el-image
              class="el-upload-list__item-thumbnail imageBox"
              :src="item.url"
              fit="cover"
              :preview-src-list="preview"
              :initial-index="preview.findIndex((n) => n == item.url)"
              hide-on-click-modal
              append-to-body
              :z-index="9999"
            >
              <template #placeholder>
                <div class="image-upload-multiple-image-slot">
                  Loading...
                </div>
              </template>
            </el-image>
            <div v-if="!disabled">
              <div class="delBox">
                  <span class="del" @click="handleRemove(item)">
                    <i class="el-icon-delete"></i>
                  </span>
                </div>
            </div>
          </div>
          <el-input v-model="item.description" style="width: 148px;" @change="handDescription(item)"></el-input>
        </div>
      <el-upload
        ref="uploader"
        list-type="picture-card"
        :auto-upload="autoUpload"
        :disabled="disabled"
        :action="action"
        :name="name"
        :data="data"
        :http-request="request"
        :file-list="defaultFileList"
        :show-file-list="false"
        :accept="accept"
        :multiple="multiple"
        :limit="limit"
        :before-upload="before"
        :on-remove="remove"
        :on-success="success"
        :on-error="error"
        :on-preview="handlePreview"
        :on-exceed="handleExceed"
      >
        <slot>
          <i class="el-icon-plus"></i>
        </slot>
        <template #tip>
          
        </template>
        <template #file="{ file }">
          <div class="image-upload-list-item">
            <el-image
              class="el-upload-list__item-thumbnail"
              :src="file.url"
              fit="cover"
              :preview-src-list="preview"
              :initial-index="preview.findIndex((n) => n == file.url)"
              hide-on-click-modal
              append-to-body
              :z-index="9999"
            >
              <template #placeholder>
                <div class="image-upload-multiple-image-slot">
                  Loading...
                </div>
              </template>
            </el-image>
            <div
              v-if="!disabled && file.status == 'success'"
              class="image-upload__item-actions"
            >
              <span class="del" @click="handleRemove(file)">
                <i class="el-icon-delete"></i>
              </span>
            </div>
            <div
              v-if="
                file.status == 'ready' || file.status == 'uploading'
              "
              class="image-upload__item-progress"
            >
              <el-progress
                :percentage="file.percentage"
                :text-inside="true"
                :stroke-width="16"
              />
            </div>
          </div>
        </template>
      </el-upload>
    </div>
    <div v-if="tip" class="tipBox">{{ tip }}</div>
    <span style="display: none !important"
        ><el-input v-model="value"></el-input
      ></span>
  </div>
</template>

<script>
import config from './config'
import Sortable from 'sortablejs'
// import cecUnmFileService from '@/api/unmfile/cecUnmFileService'
export default {
  props: {
    modelValue: { type: Array, default: () => [] },
    otherPrams: { type: Object, default: () => {} },
    tip: { type: String, default: '' },
    action: { type: String, default: '' },
    apiObj: { type: Object, default: () => {} },
    name: { type: String, default: config.filename },
    data: { type: Object, default: () => {} },
    accept: { type: String, default: 'image/gif, image/jpeg, image/png' },
    maxSize: { type: Number, default: config.maxSize },
    limit: { type: Number, default: 0 },
    autoUpload: { type: Boolean, default: true },
    showFileList: { type: Boolean, default: true },
    multiple: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    draggable: { type: Boolean, default: false },
    onSuccess: {
      type: Function,
      default: () => {
        return true
      }
    }
  },
  data () {
    return {
      value: '',
      defaultFileList: [],
      sortTableRef: null
    }
  },
  // 超级牛
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  watch: {
    modelValue (val) {
      // if (val !== this.toStr(this.defaultFileList)) {
      this.defaultFileList = this.toArr(val)
      this.value = val
      // }
    },
    defaultFileList: {
      handler (val) {
        // this.$emit('change', val)
        this.$emit('changeLisy', val)
        this.value = this.toStr(val)
      },
      deep: true
    },
    disabled: {
      handler (val) {
        if (val && this.draggable) {
          this.sortTableRef.options.disabled = false
        } else {
          if (this.draggable) {
            // this.sortTableRef.options.disabled = false
            this.rowDrop()
          }
        }
      }
    }
  },
  computed: {
    preview () {
      return this.defaultFileList.map((v) => v.url)
    }
  },
  mounted () {
    this.value = this.modelValue
    this.defaultFileList = this.toArr(this.modelValue)
    if (!this.disabled && this.draggable) {
      this.rowDrop()
    }
  },
  methods: {
    handDescription (data) {
      this.$emit('updateChange', (this.defaultFileList))
    },
// 默认值转换为数组
    toArr (str) {
      var _arr = str.map(item => {
        var urlArr = item.filePath.split('&name=')
        var fileName = urlArr[urlArr.length - 1]
        let ch = {
          id: item.id,
          name: fileName,
          description: item.description,
          url: process.env.VUE_APP_SERVER_URL + item.filePath,
          filePath: item.filePath
        }
        return ch
      })
      // var arr = str.split(',')
      // arr.forEach((item) => {
      //   if (item) {
      //     var urlArr = item.split('&name=')
      //     var fileName = urlArr[urlArr.length - 1]
      //     _arr.push({
      //       name: fileName,
      //       url: process.env.VUE_APP_SERVER_URL + item
      //     })
      //   }
      // })
      return _arr
    },
// 数组转换为原始值
    toStr (arr) {
      return arr.map((v) => v.url).join(',')
    },
    toIdStr (arr) {
      return arr.map((v) => v.id).join(',')
    },
// 拖拽
    async rowDrop () {
      const _this = this
      const itemBox = this.$el.querySelectorAll('.image-upload-multiple')[0]
      console.log(itemBox)
      this.sortTableRef = await Sortable.create(itemBox, {
        // handle: '.el-upload-list__item',
        animation: 200,
        ghostClass: 'ghost',
        onEnd ({ newIndex, oldIndex }) {
          const tableData = _this.defaultFileList
          const currRow = tableData.splice(oldIndex, 1)[0]
          tableData.splice(newIndex, 0, currRow)
          _this.$emit('updateChange', _this.defaultFileList)
        }
      })
    },
    before (file) {
      if (!['image/jpeg', 'image/png', 'image/gif'].includes(file.type)) {
        this.$message.warning(`选择的文件类型 ${file.type} 非图像类文件`)
        return false
      }
      const maxSize = file.size / 1024 / 1024 < this.maxSize
      if (!maxSize) {
        this.$message.warning(`上传文件大小不能超过 ${this.maxSize}MB!`)
        return false
      }
    },
    success (res, file, fileList) {
      var os = this.onSuccess(res, file)
      if (os !== undefined && os === false) {
        return false
      }
      var response = config.parseData(res)
      if (response.src !== undefined) {
        file.url = response.src.data.path
        this.defaultFileList = fileList.map(item => {
          if (item.url === response.src.data.path) {
            item.id = response.src.data.id
            item.filePath = response.src.data.path
            item.url = process.env.VUE_APP_SERVER_URL + response.src.data.path
          }
          return item
        })
        this.$emit('updateChange', (this.defaultFileList))
      }
    },
    remove (file, fileList) {
      this.defaultFileList = fileList
      // cecUnmFileService.delete(file.id).then(({data}) => {
      //   console.log(file, fileList)
      //   this.$emit('updateChange', (this.defaultFileList))
      // }).catch(() => {
      // })
    },
    error (err) {
      this.$notify.error({
        title: '上传文件未成功',
        message: err
      })
    },
    beforeRemove (uploadFile) {
      return this.$confirm(`是否移除 ${uploadFile.name} ?`, '提示', {
        type: 'warning'
      }).then(() => {
        return true
      }).catch(() => {
        return false
      })
    },
    handleRemove (file) {
      this.$refs.uploader.handleRemove(file)
      this.$emit('updateChange', (this.defaultFileList))
// this.defaultFileList.splice(this.defaultFileList.findIndex(item => item.uid===file.uid), 1)
    },
    handleExceed () {
      this.$message.warning(`当前设置最多上传 ${this.limit} 个文件，请移除后上传!`)
    },
    handlePreview (uploadFile) {
      window.open(uploadFile.url)
    },
    async request (param) {
      var apiObj = config.apiObj
      if (this.apiObj) {
        apiObj = this.apiObj
      }
      const data = new FormData()
      data.append(param.filename, param.file)
      for (const key in param.data) {
        data.append(key, param.data[key])
      }
      let params = {
        id: this.otherPrams.id,
        type: this.otherPrams.type,
        uploadPath: 'userdir'
      }
      await apiObj.uploadParams(data, params, {onUploadProgress: (e) => {
        const complete = parseInt(((e.loaded / e.total) * 100) | 0, 10)
        param.onProgress({ percent: complete })
      }
      }).then((res) => {
        param.onSuccess(res)
      }).catch((err) => {
        param.onError(err)
      })
    }
  }
}
</script>

<style scoped lang="less">
.el-form-item.is-error .image-upload-multiple:deep(.el-upload--picture-card) {
	border-color: var(--el-color-danger);
}
:deep(.el-upload-list__item) {
	transition: none;
	border-radius: 0;
}
.image-upload-multiple:deep(.el-upload-list__item.el-list-leave-active) {
	position: static !important;
}
.image-upload-multiple:deep(.el-upload--picture-card) {
	border-radius: 0;
}
.image-upload-list-item {
	width: 100%;
	height: 100%;
	position: relative;
}
.image-upload-multiple .el-image {
	display: block;
}
.image-upload-multiple .el-image:deep(img) {
	-webkit-user-drag: none;
}
.image-upload-multiple-image-slot {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	font-size: 12px;
}
.image-upload-multiple .el-upload-list__item:hover .image-upload__item-actions {
	display: block;
}
.image-upload__item-actions {
	position: absolute;
	top: 0;
	right: 0;
	display: none;
}
.image-upload__item-actions span {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 25px;
	height: 25px;
	cursor: pointer;
	color: #fff;
}
.image-upload__item-actions span i {
	font-size: 12px;
}
.image-upload__item-actions .del {
	background: #f56c6c;
}
.image-upload__item-progress {
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background-color: var(--el-overlay-color-lighter);
}
.content:hover {
  position: relative;
  .delBox{
    display: inline;
  }
}
.imageBox{
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  margin: 0 8px 8px 0;
  display: inline-block;
}
.tipBox{
  font-size: 12px;
  color: #606266;
  margin-top: 7px;
}
.delBox {
  // z-index: 100;
  display: none;
  position: absolute;
  top: 0;
  right: 9px;
  .del {
    background: #f56c6c;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 25px;
    height: 25px;
    cursor: pointer;
    color: #fff;
    border-start-end-radius: 6px;
  }
}


</style>
